import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export const initAnimations = () => {
  const settings = {
    duration: 0.6,
  };

  const initScrollTrigger = (tl, el, start = "top bottom-=20%") => {
    ScrollTrigger.create({
      animation: tl,
      trigger: el,
      start: () => start,
    });
  };

  const getDefaultAnim = (from, to) => {
    return [{
        opacity: 0,
        y: "100px",
        ...from,
      },
      {
        opacity: 1,
        y: 0,
        duration: settings.duration,
        stagger: 0.4,
        ease: "power1.out",
        ...to,
      },
    ];
  };

  const riseUp = document.querySelectorAll("[data-rise-up]");
  riseUp.forEach((el) => {
    let delay = window.innerWidth < 1280 && el.getAttribute('data-mobile-delay') ? el.getAttribute('data-mobile-delay') : el.getAttribute('data-delay') || 0;
    let start = el.getAttribute('data-start') || 'top bottom-=20%';
    const tl = gsap.fromTo(el, ...getDefaultAnim({}, {
      delay: delay,
      duration: settings.duration,
    }));
    if (el.closest('[data-rise-up-group]')) {
      initScrollTrigger(tl, el.closest('[data-rise-up-group]'));
    } else {
      initScrollTrigger(tl, el, start);
    }
  });

  const animRight = document.querySelectorAll('[data-anim-right]');
  animRight.forEach((el) => {
    let delay = el.getAttribute('data-delay') || 0;
    let start = el.getAttribute('data-start') || 'top bottom-=30%';
    const tl = gsap.fromTo(el, {
      x: '100px',
      opacity: 0,
    }, {
      x: 0,
      opacity: 1,
      duration: settings.duration,
      ease: "power1.out",
      delay: delay,
    });
    initScrollTrigger(tl, el, start);
  });

  const animLeft = document.querySelectorAll('[data-anim-left]');
  animLeft.forEach((el) => {
    let delay = el.getAttribute('data-delay') || 0;
    let start = el.getAttribute('data-start') || 'top bottom-=30%';
    const tl = gsap.fromTo(el, {
      x: '-100px',
      opacity: 0,
    }, {
      x: 0,
      opacity: 1,
      duration: settings.duration,
      ease: "power1.out",
      delay: delay,
    });
    initScrollTrigger(tl, el, start);
  });

  const listRiseUpAnim = document.querySelectorAll('[data-rise-list]');
  listRiseUpAnim.forEach((el) => {
    const items = el.querySelectorAll('[data-rise-item]');
    let start = el.getAttribute('data-start') || 'top bottom-=-20%';
    let delay = window.innerWidth < 1280 && el.getAttribute('data-mobile-delay') ? el.getAttribute('data-mobile-delay') : el.getAttribute('data-delay') || 0;
    const tl = gsap.fromTo(items, {
      y: '100',
      opacity: 0,
    }, {
      y: 0,
      opacity: 1,
      duration: settings.duration,
      ease: "ease",
      delay: delay,
      stagger: 0.2,
    });

    initScrollTrigger(tl, el, start);
  });

  const listLeftAnim = document.querySelectorAll('[data-left-list]');
  listLeftAnim.forEach((el) => {
    const items = el.querySelectorAll('[data-left-item]');
    let delay = el.getAttribute('data-delay') || 0;
    let start = el.getAttribute('data-start') || 'top bottom-=-20%';
    const tl = gsap.fromTo(items, {
      x: '-100px',
      opacity: 0,
    }, {
      x: 0,
      opacity: 1,
      duration: settings.duration,
      ease: "ease",
      delay: delay,
      stagger: 0.2,
    });

    initScrollTrigger(tl, el, start);
  });

  // Subtle parallax for hero background and content
  const heroes = document.querySelectorAll('.hero');
  heroes.forEach((hero) => {
    //const bgImg = hero.querySelector('.hero__bg img');
    const content = hero.querySelector('.hero__wrapper');

   /* if (bgImg) {
      gsap.fromTo(
        bgImg,
        { y: '-20%' },
        {
          y: '20%',
          ease: 'none',
          scrollTrigger: {
            trigger: hero,
            start: 'top bottom',
            end: 'bottom top',
            scrub: true,
          },
        },
      );
    } */

    if (content) {
      gsap.fromTo(
        content,
        { y: '-8%' },
        {
          y: '8%',
          ease: 'none',
          scrollTrigger: {
            trigger: hero,
            start: 'top bottom',
            end: 'bottom top',
            scrub: true,
          },
        },
      );
    }
  });
}
